import { defAction } from "../../../../helpers/defaultAction"
import {reBuildTypeConstants} from "./constants"
import api from './api'

export const buildTypesActions = {
	getBuildTypes,
	clearBuildTypes
}

function getBuildTypes(values){
	const dispatchObj = {
		constants : reBuildTypeConstants.GetBuildTypes,
		service   : {
			func   : api.getBuildTypes,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clearBuildTypes(){
	return (dispatch) => dispatch({	type: reBuildTypeConstants.ClearBuildTypes })
}